/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StepFromJSON, StepToJSON, TutorialAnchorFromJSON, TutorialAnchorToJSON, TutorialStateExitedFromJSON, TutorialStateExitedToJSON, } from './';
export function TutorialStateFromJSON(json) {
    return TutorialStateFromJSONTyped(json, false);
}
export function TutorialStateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tutorialId': !exists(json, 'tutorial_id') ? undefined : json['tutorial_id'],
        'inResponseToWallItemId': !exists(json, 'in_response_to_wall_item_id') ? undefined : json['in_response_to_wall_item_id'],
        'anchor': !exists(json, 'anchor') ? undefined : TutorialAnchorFromJSON(json['anchor']),
        'step': !exists(json, 'step') ? undefined : StepFromJSON(json['step']),
        'exited': !exists(json, 'exited') ? undefined : TutorialStateExitedFromJSON(json['exited']),
    };
}
export function TutorialStateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tutorial_id': value.tutorialId,
        'in_response_to_wall_item_id': value.inResponseToWallItemId,
        'anchor': TutorialAnchorToJSON(value.anchor),
        'step': StepToJSON(value.step),
        'exited': TutorialStateExitedToJSON(value.exited),
    };
}
//# sourceMappingURL=TutorialState.js.map